import { Component, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CorrectYeKeService } from 'projects/sepidz-web-framework/src/lib/services';
import { BaseControlComponent } from '../base/base-control.component';
import { SelectorService } from '../base/selector.service';
@Component({
  //moduleId: module.id,
  selector: 'ssg-textarea',
  styleUrls: ['textarea.component.scss'],
  templateUrl: 'textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextareaComponent extends BaseControlComponent<string> {
  isshow: boolean;
  inputFocus: boolean;

  ngAfterViewChecked() {
    super.ngAfterViewChecked();
    if (this.f[this.name].value && (this.f[this.name].value !== '' && this.f[this.name].value !== undefined && this.f[this.name].value !== null)) {
      this.isshow = true;
    }
  }
  show() {
    this.isshow = !this.isshow;
  }
  focusFunction() {
    this.isshow = true;
    this.inputFocus = true;
    if (document.getElementById(this.name))
      document.getElementById(this.name).focus();
  }
  focusOutFunction() {
    if (!this.f[this.name].value || this.f[this.name].value === '') {
      this.isshow = false;
      this.inputFocus = false;
    }
  }
  // @HostBinding('class') @Input('class') classList: string = '';

  @Input() class: string
  @Input() name: string;
  @Input() hint: string;
  @Input() icon: string;
  @Input() autocomplete: string = "off";
  @Input() withComma: boolean = true;
  @Output() numberValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() inputMask: string;
  @Input()
  set numberValue(value: any) {
    if (value && this.textType === 'number' && this.withComma.toString().toLowerCase() === 'true') {
      var parts = value.toString().split(".");
      parts[0] = parts[0].replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.f[this.name].setValue(parts.join("."));
    }
    else
      this.f[this.name].setValue(value as any)
  }
  get numberValue(): any {
    if (this.textType === 'number' && this.withComma.toString().toLowerCase() === 'true') {
      return Number(this.f[this.name].value.replace(/,/g, ""));
    }
    return this.f[this.name].value as any;
  }
  constructor(private cyk: CorrectYeKeService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    if (!this.autocomplete) {
      this.autocomplete = "off";
    }
  }
  onChange(value: any) {
    if (value && this.textType === 'number' && this.withComma.toString().toLowerCase() === 'true') {
      this.valueChange.emit(this.f[this.name].value.replace(/,/g, ""));
      this.numberValueChange.emit(this.numberValue)
    }
    else {
      value = CorrectYeKeService.getCorrectYeKe(value);
      this.f[this.name].setValue(value);
      this.valueChange.emit(value);
      this.numberValueChange.emit(this.numberValue)
    }
  }
}
